










































































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    Action
} from "vuex-class";
import {
    SERCH_STORE
} from "../store/actions.names";
//import Mapbox from "mapbox-gl-vue";

@Component({
    name: "storelocatormapcomp"
})
export default class StoreLocatorMap extends Vue {
    @Action(SERCH_STORE)[SERCH_STORE]: any;
    @Prop() compData!: any;
    search: string = "";
    stores: any = [];
    center: any = {
        lat: parseFloat(this.compData.latitude),
        lng: parseFloat(this.compData.longitude)
    };

    get defaultCenter() {
        return {
            lat: parseFloat(this.compData.latitude),
            lng: parseFloat(this.compData.longitude)
        };
    }

    @Watch("stores", {
        deep: true
    })
    handleStoreChange(val: any, oldVal: any) {
        if (this.stores.length !== 0) {
            let lats: number[] = [];
            let lngs: number[] = [];
            this.stores.forEach((element: any) => {
                lats.push(element.latitude);
                lngs.push(element.longitude);
            });
            lats.sort();
            lngs.sort();
            this.center = {
                lat: (lats[0] + lats[lats.length - 1]) / 2,
                lng: (lngs[0] + lngs[lngs.length - 1]) / 2
            };
        } else {
            this.center = this.defaultCenter;
        }
    }
    @Watch("search")
    handleSearchChange(val: string, oldVal: string) {
        if (val != oldVal) {
            this[SERCH_STORE](val).then((data: any) => {
                this.stores = data.map((item: any, idx: number) => {
                    item.latitude = parseFloat(item.latitude);
                    item.longitude = parseFloat(item.longitude);
                    return item;
                });
            });
        }
    }
    // mapLoaded(map: any) {
    //   map.addLayer({
    //     id: "points",
    //     type: "symbol",
    //     source: {
    //       type: "geojson",
    //       data: {
    //         type: "FeatureCollection",
    //         features: [
    //           {
    //             type: "Feature",
    //             geometry: {
    //               type: "Point",
    //               coordinates: [-77.03238901390978, 38.913188059745586]
    //             },
    //             properties: {
    //               title: "Mapbox DC",
    //               icon: "monument"
    //             }
    //           },
    //           {
    //             type: "Feature",
    //             geometry: {
    //               type: "Point",
    //               coordinates: [-122.414, 37.776]
    //             },
    //             properties: {
    //               title: "Mapbox SF",
    //               icon: "harbor"
    //             }
    //           }
    //         ]
    //       }
    //     },
    //     layout: {
    //       "icon-image": "{icon}-15",
    //       "text-field": "{title}",
    //       "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
    //       "text-offset": [0, 0.6],
    //       "text-anchor": "top"
    //     }
    //   });
    // }
    // mapClicked(map: any, e: any) {
    //   alert("Map Clicked!");
    // }
    // geolocateError(control: any, positionError: any) {
    //   console.log(positionError);
    // }
    // geolocate(control: any, position: any) {
    //   console.log(
    //     `User position: ${position.coords.latitude}, ${position.coords.longitude}`
    //   );
    // }
    // mapInitialized(map: any) {
    //     const Draw = new (this as any).MapboxDraw();
    //     map.addControl(Draw);
    //   }

    //update lists
}
